import { Empty, Typography, Divider, Space } from "antd";
import React from "react";

/**
 * Convenience component to display a placeholder with replaced default image and text when no data is found
 * @param imgUrl
 * @param text
 * @param height
 * @param maxWidth
 * @param action
 * @returns {JSX.Element}
 * @constructor
 */
const Placeholder = ({
    imgUrl = 'https://storage.googleapis.com/finiat-web-static-resources/utility/placeholder-3.svg',
    text = 'No Data Found...',
    height = 200,
    maxWidth = 400,
    action,
    minHeight=300
}) => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
            minHeight // Adjust as needed
        }}>
            <Empty
                image={imgUrl}
                imageStyle={{
                    height: height,
                    objectFit: 'contain',
                    display: 'block',
                    margin: '0 auto'
                }}
                style={{
                    maxWidth: maxWidth,
                    textAlign: 'center',
                }}
                description={
                    <Space direction="vertical" size="large" style={{ display: 'flex', alignItems: 'center' }} className={'pt-5'}>
                        <Typography.Text>{text}</Typography.Text>
                        {action}
                    </Space>
                }
            />
        </div>
    );
};

export default Placeholder;
